import { Splide } from "https://cdn.jsdelivr.net/npm/@splidejs/splide@4/+esm";
import { AutoScroll } from "https://cdn.jsdelivr.net/npm/@splidejs/splide-extension-auto-scroll@0.5.3/+esm";
(()=>{
  const sliderWrapper = document.querySelector(".video-reviews__swiper-wrapper")
  const speed = Number(document.querySelector(".video-reviews__wrapper").dataset.speed);
  const splide = new Splide(".splide.video-reviews__swiper", {
    type: "loop",
    drag: "free",
    focus: "center",
    perPage: 6,
    autoScroll: {
      speed: speed
    },
    autoWidth:  true,
    gap: 16,
    pagination: false,
    arrows: false,
  });
  
  splide.mount({ AutoScroll });
  
  class VideoComponent extends HTMLElement {
    constructor() {
      super();
      this.video = this.querySelector("video");
      this.buttonStart = this.querySelector(".video-reviews__button");
      this.content = this.querySelector(".video-reviews__above-video");
      this.image = this.querySelector(".video-reviews__image");
  
      this.wrapper = this.closest("ul");
      this.clones = [
        ...this.wrapper.querySelectorAll(`[data-id="${this.dataset.id}"]`),
      ].filter((el) => el != this);
  
      this.setEventListeners();
    }
    setEventListeners() {
      this.buttonStart.addEventListener("click", this.startVideo.bind(this));
      this.image?.addEventListener("click", this.startVideo.bind(this));
      this.content.addEventListener("click", this.startVideo.bind(this));
      this.video.addEventListener("ended", this.videoFinish.bind(this));
      // this.video.addEventListener("pause", this.autoplaySlider.bind(this));
      this.video.addEventListener("play", this.videoPlay.bind(this));
      // this.video.addEventListener("seeked", this.onVideoSeeking.bind(this));
      this.video.addEventListener("fullscreenchange", this.toggleVideoFullScreen.bind(this))
    }
  
    videoFinish() {
      // this.clones.forEach((clone) => (clone.video.currentTime = this.video.currentTime));
      this.content.style.display = "flex";
      this.video.removeAttribute("controls");
      if (this.image) {
        this.image.style.opacity = 1;
        this.image.style.visibility = "visible";
      }
      this.video.controls=false;
    }
    pausePlayedVideos(){
      const playedVideo = [...this.wrapper.querySelectorAll(".video-reviews__component")].find(component=>!component.video.paused);
      if(playedVideo != this){
        playedVideo?.video.pause();
      }
    }
    startVideo() {
      // this.clones.forEach((clone) => {
      //   clone.content.style.display = "none";
      //   clone.video.setAttribute("controls", "controls");
      //   // clone.video.play();
      //   if (clone.image) {
      //     clone.image.style.opacity = 0;
      //     clone.image.style.visibility = "hidden";
      //   }
      // });
  
      this.content.style.display = "none";
      this.video.setAttribute("controls", "controls");
      this.video.play();
      this.video.focus();
     
      if (this.image) {
        this.image.style.opacity = 0;
        this.image.style.visibility = "hidden";
      }

    }
    // autoplaySlider() {
    //   // this.clones.forEach((clone) => clone.video.pause());
    //   this.video.muted=true;
    //   this.dataset.play= "false";
    // }
    videoPlay() {
      const playedVideo = [...this.wrapper.querySelectorAll(".video-reviews__component")].find(component=>!component.video.paused && component!=this);
      // const playedVideo = [...this.wrapper.querySelectorAll(".video-reviews__component")].find(component=>!component.video.paused && component!=this && !this.clones.includes(component));

      playedVideo?.video.pause();
  
      // this.clones.forEach((clone) => clone.video.play());
      this.video.controls=true;
      this.dataset.play= "true";
    }
    // async onVideoSeeking() {
    //   if (this.video.ended) return;
  
    //   this.clones.forEach(async (clone) => {
    //     const diff = Math.abs(clone.video.currentTime - this.video.currentTime);
    //     if (diff > 0.1) {
    //       clone.video.currentTime = this.video.currentTime;
    //     }
    //   });
    // }
    toggleVideoFullScreen(){
      if(document.fullscreenElement){
        this.video.style.objectFit = "contain";
      }else{
        this.video.style.objectFit = "cover";
      }

    }

  }
  customElements.define("video-component", VideoComponent);
  
  // sliderWrapper.addEventListener("click", toggleMute, true);

  function toggleMute(event){
    const closest = event.target.closest("video-component");
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-play') {
          const targetVideo = mutation.target.video;
          const value = mutation.target.dataset.play;
          if(value === "true"){
            targetVideo.muted = false;
          }
          observer.disconnect();
        }
      });
    });
    
    const config = { attributes: true, attributeOldValue: true };
    observer.observe(closest, config);
  }
})();

